import { useQuery } from '@tanstack/react-query';
import { certificadoService } from '../../shared/services';
import { Award, Download, ExternalLink } from 'lucide-react';

export function CertificatesPage() {
  const { data: certificados, isLoading } = useQuery({
    queryKey: ['certificados'],
    queryFn: certificadoService.getMeusCertificados,
  });

  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Meus Certificados</h1>
          <p className="text-gray-600 mt-2">Certificados conquistados nos seus cursos</p>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
          </div>
        ) : certificados && certificados.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {certificados.map((cert) => (
              <div key={cert.id} className="card">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
                    <Award className="text-yellow-600" size={24} />
                  </div>
                  <div className="flex-1">
                    <p className="text-sm text-gray-600">Certificado</p>
                    <p className="font-semibold text-gray-900">{cert.codigoValidacao}</p>
                  </div>
                </div>

                <p className="text-sm text-gray-600 mb-4">
                  Emitido em {new Date(cert.emitidoEm).toLocaleDateString('pt-BR')}
                </p>

                <div className="flex gap-2">
                  <a
                    href={cert.pdfUrl}
                    download
                    className="flex-1 btn-primary flex items-center justify-center gap-2"
                  >
                    <Download size={16} />
                    <span>Download</span>
                  </a>
                  <a
                    href={`/certificados/validar/${cert.codigoValidacao}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-secondary flex items-center justify-center"
                  >
                    <ExternalLink size={16} />
                  </a>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="card text-center py-12">
            <Award className="mx-auto text-gray-400 mb-4" size={64} />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Nenhum certificado ainda
            </h3>
            <p className="text-gray-600 mb-6">
              Complete cursos para ganhar certificados
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
